import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=04597382&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04597382')) {
      api.createRecord('04597382', component.options)
    } else {
      api.reload('04597382', component.options)
    }
    module.hot.accept("./InviteModal.vue?vue&type=template&id=04597382&", function () {
      api.rerender('04597382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Modal/InviteModal.vue"
export default component.exports